import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { LanguageService } from './language.service';

export interface Translations {
  next: string;
  submit: string;
  emailVerification: string;
  subtitle: string;
  emailLabel: string;
  emailPlaceholder: string;
  verifyButton: string;
  emptyCaptcha: string;
  otpLabel: string;
  otpPlaceholder: string;
  otpnotreceived: string;
  otpempty: string;
  submitButton: string;
  resendButton: string;
  backButton: string;
  verificationSuccess: string;
  proceedButton: string;
  sendOtpButton: string;
  emailInvalid: string;
  otpRequired: string;
  otpSent: string;
  otpError: string;
  otpVerified: string;
  sendOtpError: string;
  footer: string;
  authenticationFalied(authenticationFalied: any): string | undefined;
  otpSentSuccess: string;
  otpResendSuccess: string;
  otpVerifySuccess: string;
  otpVerifyError: string;
  otpSendError: string;
  connectionError: string;
  serviceUnavailable: string;
  formSubmit: string;
  enterOtp: string;
  customerOnBoarding: string;
  companyDetails: string;
  serviceAgreement: string;
  userAccounts: string;
  userDetails: string;
  review: string;
  companyName: string;
  companyNameRequired: string;
  billingEmail: string;
  billingEmailRequired: string;
  billingEmailPlaceholder: string;
  businessNumber: string; // This and below two are displayed as Business Phone Number
  businessNumberRequired: string;
  businessNumberPlaceholder: string;
  taxId: string;
  taxIdRequired: string;
  taxIdType: string;
  taxIdTypeRequired: string;
  companyNamePlaceholder: string;
  companyNameDuplicate: string;
  taxIdTypePlaceholder: string;
  taxIdPlaceholder: string;
  language: string;
  languagePlaceholder: string;
  languageRequired: string;
  languages : {
    english : string;
    chinese : string;
  };
  taxIdTypes: {
    PAN: string;
    GSTIN: string;
    TIN: string;
  };
  address: string;
  country: string;
  countryRequired: string;
  state: string;
  stateRequired: string;
  street: string;
  streetRequired: string;
  street2: string;
  street2Placeholder: string;
  suburb: string;
  suburbRequired: string;
  city: string;
  cityRequired: string;
  postcode: string;
  postcodeRequired: string;
  streetPlaceholder: string;
  countryPlaceholder: string;
  statePlaceholder: string;
  suburbPlaceholder: string;
  cityPlaceholder: string;
  postcodePlaceholder: string;
  customerId: string;
  downloadButton: string;
  uploadTitle: string;
  uploadRequired: string;
  confirmCheckbox: string;
  confirmRequired: string;
  registrationTitle: string;
  registrationRequired: string;
  beforeProceeding: string;
  termsLink: string;
  agreedBy: string;
  agreedByPlaceholder: string;
  agreedByRequired: string;
  userTitle: string;
  username: string;
  usernameRequired: string;
  usernameMinLength: string;
  firstName: string;
  firstNameRequired: string;
  firstNameMinLength: string;
  lastName: string;
  lastNameRequired: string;
  email: string;
  emailRequired: string;
  mobileNumber: string;
  mobileRequired: string;
  wechatId: string;
  wechatRequired: string;
  addUserButton: string;
  userNameAlreadyExists: string;
  mobileNumberPlaceholder: string;
  weChatId: string;
  weChatIdPlaceholder: string;
  deleteUserButton: string;
  confirmText: string;
  unexpectedError : string;
  tryAgain : string;
  sessionExpired : string;
  back: string;
  edit: string;
  completion: string;
  message: string;
  dashboardButton: string;
  required: string;
  loading: string;
  error: string;
  success: string;
  english: string;
  chinese: string;
  termsAndConditions: string;
  agreementText: string;
  scroll: string;
  continue: string;
  signContract: string;
  fullName: string;
  fullNameRequired: string;
  fullNameMinLength: string;
  signature: string;
  drawSignatureAbove: string;
  clear: string;
  close: string;
  fullNamePlaceholder: string;
  signNow: string;
  software: string;
  softwarePlaceholder: string;
}

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private readonly defaultLang = 'en_AU';
  private translationsSubject = new BehaviorSubject<Translations>(
    {} as Translations
  );
  translations$ = this.translationsSubject.asObservable();

  constructor(
    private readonly translate: TranslateService,
    private http: HttpClient,
    private languageService: LanguageService
  ) {
    // Subscribe to language changes
    this.languageService.currentLanguage$.subscribe((language) => {
      this.loadTranslations(language);
    });
  }

  private loadTranslations(language: string): void {
    this.http.get<Translations>(`/assets/i18n/${language}.json`).subscribe({
      next: (translations) => {
        this.translationsSubject.next(translations);
      },
      error: (error) => {
        console.error('Error loading translations:', error);
        // If loading fails, fall back to empty translations
        this.translationsSubject.next({} as Translations);
      },
    });
  }

  getCurrentLang(): string {
    return this.translate.currentLang || this.defaultLang;
  }

  getCurrentTranslations(): Translations {
    return this.translationsSubject.value;
  }
}
